import React, { Component } from 'react'
import './styles.scss'
import ToolTip from '../ToolTip'
import PropTypes from 'prop-types'

class Icon extends Component {
  render () {
    const classNames = ['Icon', 'ToolTip-Handle']

    if (this.props.size) {
      classNames.push('Icon-' + this.props.size)
    }

    if (this.props.type) {
      classNames.push('Icon-' + this.props.type)
    }

    if (this.props.background) {
      classNames.push('Icon-BG-' + this.props.background)
    }
 
    return (
      <span
        className={classNames.join(' ')}
        onClick={this.props.onClick}>
                {this.props.tooltip &&
                  <ToolTip>{this.props.tooltip}</ToolTip>
                }
        {this.props.type === 'fa' ? (
          <i className={'fa ' + this.props.faClassName}/>
        ) : (
          <span/>
        )}
            </span>
    )
  }
}

Icon.defaultProps = {
  size: 'default'
}

Icon.propTypes = {
  size: PropTypes.string,
  type: PropTypes.string.isRequired,
  background: PropTypes.string,
  tooltip: PropTypes.any,
  faClassName: PropTypes.string
}

export default Icon
